import PropTypes from 'prop-types';
import { isNil } from 'lodash/fp';
import { Button, ButtonVariant } from 'app/components/core/Button';
import { useFormContext } from './Form.jsx';

export function Submit({ children, ...others }) {
    const context = useFormContext();

    if (isNil(context)) {
        throw new Error('<Submit> must be used within a <Form> component');
    }

    const { isSubmitting, isPristine, isFormValid } = context;

    const props = {
        type: 'submit',
        variant: ButtonVariant.PRIMARY,
        ...others,
        isProcessing: isSubmitting,
        disabled: Boolean(others.disabled) || isPristine || !isFormValid
    };

    return <Button {...props}>{children}</Button>;
}

Submit.propTypes = {
    /** The label content of the submit button. */
    children: PropTypes.node
};
